import ReactDOM from 'react-dom';
import { getPortalContainer } from 'utils/contents';
import styles from './styles.module.scss';
const topbarFieldContainer = getPortalContainer('topbar-field');
function TopbarField({ children }) {
    const content = React.createElement("span", { className: styles.root }, children);
    return ReactDOM.createPortal(content, topbarFieldContainer);
}
export default TopbarField;
